import { Col, Row } from "react-bootstrap";

import StaticField from "../../../../components/StaticField";
import type { LearningSet, Module } from "../../../../models/ProgramRequest";

export const renderPlaceholderField = (label: string) => <StaticField label={label} value="--" />;

export const renderStringFields = (label: string, values: string[]) => (
  <>
    {values.map((value, idx) => (
      <StaticField key={idx} label={label} value={value || "--"} />
    ))}
  </>
);

export const renderStringFieldsOrPlaceholder = (label: string, values: string[]) =>
  values.length > 0 ? renderStringFields(label, values) : renderPlaceholderField(label);

export const renderModules = (t: (key: string) => string, modules: Module[]) => {
  if (modules.length === 0) {
    return (
      <Row>
        <Col md={12} className="mt-3">
          <StaticField label={t("request.modules")} value="--" />
        </Col>
      </Row>
    );
  }

  return (
    <>
      {modules.map((module: Module, modIdx: number) => (
        <div key={modIdx} className="mt-3">
          <Row>
            <Col md={12}>
              <StaticField label={t("request.moduleName")} value={module.name || "--"} />
            </Col>
          </Row>
          {(module.learningSets ?? []).map((ls: LearningSet, lsIdx: number) => (
            <Row key={lsIdx}>
              <Col md={12}>
                <StaticField label={t("request.moduleLearningSetName")} value={ls.name || "--"} />
              </Col>
              <Col md={4}>
                <StaticField label={t("request.moduleLearningSetCode")} value={ls.code || "--"} />
              </Col>
              <Col md={4}>
                <StaticField label={t("request.moduleLearningSetLevel")} value={ls.level ?? "--"} />
              </Col>
              <Col md={4}>
                <StaticField label={t("request.moduleLearningSetCSVET")} value={ls.csvet ?? "--"} />
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </>
  );
};

